import { ContentService, HasSubscriptionsToClose } from '@agingplan';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { GlobalMetadata, NgxMetaService } from '@davidlj95/ngx-meta/core';
import { JsonLdMetadata } from '@davidlj95/ngx-meta/json-ld'
import { StandardMetadata } from '@davidlj95/ngx-meta/standard';
import { environment } from 'src/environments/environment';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss'],
})
export class EmployeeComponent extends HasSubscriptionsToClose() implements OnInit, OnDestroy {
  public employee$ = this.contentService.employee$;

  public get image_src(): string {
    return `${environment.google.bucket}/assets/pages/employees/${this.employee$.value?.large_image_url}` || '';
  }

  constructor(
    private contentService: ContentService,
    private activatedRoute: ActivatedRoute,
    private readonly ngxMetaService: NgxMetaService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    // Clear meta tags before navigation
    this.subscribeTo(
      this.router.events.pipe(
        filter(event => event instanceof NavigationStart),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        this.ngxMetaService.clear();
      })
    );

    this.subscribeTo(
      this.contentService.employees$.subscribe((employees) => {
        if (employees.length) {
          // Get the index
          const index = parseInt(this.activatedRoute.snapshot.paramMap.get('index') || '0');

          // Navigate to the page
          this.contentService.navigateToPageIndex('about', index);
        }
      }),
    );

    this.subscribeTo(this.employee$.subscribe((employee) => {
      if (employee) {
        const index = this.activatedRoute.snapshot.paramMap.get('index') || '0';

        this.ngxMetaService.set({
          title: employee.name + ' | Agingplan',
          description: `Learn more about ${employee.name}.`,
          image: {
            url: `${environment.google.bucket}/assets/pages/employees/${employee.small_image_url}`,
            alt: employee.name,
          },
          standard: {
            keywords: ['team member', 'employee', 'about', 'agingplan', employee.name],
          },
          jsonLd: {
            '@context': 'https://schema.org',
            '@type': 'Person',
            name: employee.name,
            image: `${environment.google.bucket}/assets/pages/employees/${employee.small_image_url}`,
            url: `${environment.web_url}/about/employee/${index}`,
            description: `Learn more about ${employee.name}.`,
          },
        } satisfies GlobalMetadata & StandardMetadata & JsonLdMetadata);
      } else {
        this.ngxMetaService.clear();
      }
    }));
  }

  ngOnDestroy(): void {
    this.ngxMetaService.clear();
    this.employee$.next(undefined);
  }
}
